import React, {Component} from "react";


class ButtonSubmit extends Component {
    constructor(props) {
        super(props);

        this.click = this.click.bind(this);
    }

    click(e) {
        this.props.onChange(e);
    }

    render() {
        return (
            <button type="submit" className="coreBlockItem-typeSubmit"
                    name="BLOCK_ITEM_SUBMIT_ID"
                    value={this.props.blockItem.id}
                    style={JSON.parse(this.props.blockItem.inputCss)}
                    onClick={this.click}>{this.props.blockItem.label}</button>
        );
    }
}

export default ButtonSubmit;